import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/Domain/components/Shared/AlertDialog/AlertDialog';
import { Button } from '@/Domain/components/Shared/Button/Button';
import { Separator } from '@/Domain/components/Shared/Separator/Separator';
import { MODAL_NAMES, useModalStore } from '@/Domain/store/modal.store';

export const RefreshArticlesLimitDialog = () => {
  const { t } = useTranslation('knowledge_base');
  const { isOpen, closeModal } = useModalStore();

  return (
    <AlertDialog
      open={isOpen(MODAL_NAMES.REFRESH_ARTICLES_LIMIT_DIALOG)}
      onOpenChange={(open) => !open && closeModal()}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('refresh_limit_modal.title')}</AlertDialogTitle>
          <AlertDialogDescription>{t('refresh_limit_modal.description')}</AlertDialogDescription>
        </AlertDialogHeader>
        <Separator />
        <AlertDialogFooter>
          <Button variant="secondary" onClick={closeModal}>
            {t('refresh_limit_modal.ok')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
